<script>
import sound from '@/services/sound'

export default {
  name: 'StyledButton',

  props: {

    sound: {
      default: false
    },

    on: {
      default: false
    },

    pulsate: {
      default: false
    },

    red: {
      default: false
    }

  },

  computed: {

    color () {
      return this.red ? 'red' : 'green'
    }

  },

  watch: {

    on (isOn, wasOn) {
      if (isOn && !wasOn) {
        if (this.sound) {
          sound.play('buttonPress4')
        }

        this.$emit('on')
      } else if (!isOn && wasOn) {
        this.$emit('off')
      }
    }

  }

}
</script>

<template>
  <div
    :class="{
      ['c-led-' + color]: true,
      'c-led-on': on,
      'c-led-off': !on,
      'c-led-pulsate': pulsate
    }"
    class="c-led"
  >
    <div class="c-led-content">
      <div class="c-led-dot" />
    </div>
  </div>
</template>

<style lang="scss">

@keyframes c-led-pulsate {

  0%,
  45% {
    opacity: 1;
  }

  55%,
  95%,
  100% {
    opacity: 0;
  }

}

.c-led {
  @include relative;
  width: 1rem;
  height: 1rem;
}

.c-led-content {
  @include keep-full-center;
}

.c-led-on {
  .c-led-content {
    animation-name: flicker-subtle;
    animation-duration: 4150ms;
    animation-iteration-count: infinite;
  }
}

.c-led-on {
  &.c-led-pulsate {
    animation-name: c-led-pulsate;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
}

.c-led-dot {
  @include round;
  width: 0.25rem;
  height: 0.25rem;
}

// Colors

.c-led-green {
  .c-led-dot {
    background-color: $green;
  }
}

.c-led-red {
  .c-led-dot {
    background-color: $red;
  }
}

.c-led-on {
  &.c-led-green {
    .c-led-dot {
      box-shadow: 0 0 1rem 0.25rem rgba($green, 0.5);
    }
  }
}

.c-led-on {
  &.c-led-red {
    .c-led-dot {
      box-shadow: 0 0 1rem 0.25rem rgba($red, 0.5);
    }
  }
}

.c-led-off {
  .c-led-dot {
    background-color: translucent($default-text-color);
  }
}

</style>
